import React from 'react';
import { COMPANY_NAME, LOGO_SRC } from '@/lib/brand';

type CompanyLogoProps = {
  className?: string;
  imgClassName?: string;
};

const CompanyLogo: React.FC<CompanyLogoProps> = ({ className, imgClassName }) => (
  <span className={className ?? 'inline-flex items-center justify-center'}>
    <img
      src={LOGO_SRC}
      alt={COMPANY_NAME}
      className={imgClassName ?? 'h-full w-full object-contain'}
      width={180}
      height={72}
      decoding="async"
    />
  </span>
);

export default CompanyLogo;
